import React from 'react';
import styles from './ProgressBar.module.scss';

function ProgressBar({ message, width, percent }) {
  return (
    <>
      <div className={`${styles.text} mb-3`}>
        {message} : {percent}%
      </div>
      <div className={`progress ${width}`}>
        <div
          style={{ width: `${percent}%` }}
          className="progress-bar"
          role="progressbar"
          aria-label="Basic example"
          aria-valuenow={percent}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
    </>
  );
}

export default ProgressBar;
